<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Razão Social</option>
                                </select>
                            </div>
                            <div class="col-sm-8 col-md-6 col-lg-6">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstfiliais"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.codfil }}
                                    </template>
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstfiliais.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-10" style="margin-bottom: 15px;">
                                <div class="row">
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edid">Código:</label>
                                        <input type="text" class="form-control form-control-sm" id="edid" v-model="vcodfil"
                                            maxlength="20" disabled/>
                                    </div>
                                    <div class="col-sm-12 col-md-10 col-lg-10">
                                        <label for="eddescricao">*Razão Social:</label>
                                        <input type="text" v-model="vdescfil" v-bind:disabled="ativadesativa"
                                            class="form-control form-control-sm" id="eddescricao" maxlength="50">
                                    </div>
                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                        <label for="edfantasia">*Fantasia:</label>
                                        <input type="text" v-model="vfantasia" v-bind:disabled="ativadesativa"
                                            class="form-control form-control-sm" id="edfantasia" data-bv-group=".group" maxlength="50">
                                    </div>
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edcnpj">*CNPJ:</label>
                                        <input type="text" v-mask="'##.###.###/####-##'"
                                            class="form-control form-control-sm" id="edcnpj" v-model="vcnpj"
                                            v-bind:disabled="ativadesativa" data-bv-group=".group"
                                            maxlength="20">
                                    </div>
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edie">Insc. Estadual:</label>
                                        <input type="text" class="form-control form-control-sm" id="edie" v-model="vie"
                                            data-bv-group=".group" maxlength="20" v-bind:disabled="ativadesativa">
                                    </div>
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="ediest">Insc. Estadual ST:</label>
                                        <input type="text" class="form-control form-control-sm" id="ediest" v-model="viest"
                                            data-bv-group=".group" maxlength="20" v-bind:disabled="ativadesativa">
                                    </div>                                    
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edim">Inscrição Municipal:</label>
                                        <input type="text" v-model="vim" v-bind:disabled="ativadesativa"
                                            class="form-control form-control-sm" id="edim" maxlength="15">
                                    </div>                                     							
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edfone1">*Fone(1):</label>
                                        <input type="text" v-mask="['(##) ####-####', '(##) #####-####']" class="form-control form-control-sm" id="edfone1"
                                            v-model="vfone1" data-bv-group=".group" v-bind:disabled="ativadesativa"
                                            maxlength="20">
                                    </div>
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edfone2">Fone(2):</label>
                                        <input type="text" v-mask="['(##) ####-####', '(##) #####-####']" class="form-control form-control-sm" id="edfone2"
                                            v-model="vfone2" v-bind:disabled="ativadesativa" data-bv-group=".group"
                                            maxlength="20">
                                    </div>
                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                        <label for="edemail">E-mail:</label>
                                        <input type="email" class="form-control form-control-sm" id="edemail" v-model="vemail"
                                            data-bv-group=".group" v-bind:disabled="ativadesativa" maxlength="100">
                                    </div>
                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                        <label for="edsite">Site:</label>
                                        <input type="text" class="form-control form-control-sm" id="edsite" v-model="vsite"
                                            data-bv-group=".group" v-bind:disabled="ativadesativa" maxlength="100">
                                    </div>
                                </div>
                            </div>	
                            <div class="col-md-2">
                                <div class="row text-center" style="padding: 0px 15px 0px 15px; margin-bottom: 15px;">
                                    <div class="col-md-12 border rounded" style="padding: 0px;">
                                        <input
                                            type="file" 
                                            id="ipselecionarimgfilial"
                                            accept="image/png, image/jpeg" 
                                            @change="mtdselecionarimagemfilial" 
                                            style="display: none;"
                                            ref="if_imgfilial">
                                        <button v-if="parseInt(opcrud) < 3" type="button" class="btn btn-danger btn-sm btn-del-imgfilial" @click.prevent="mtdexcluirimgfilial()"><i class="fa fa-trash"></i></button>
                                        <img v-if="parseInt(opcrud) < 3" @click="$refs.if_imgfilial.click()" class="img-fluid img-filial" title="Clique aqui para selecionar uma imagen" v-bind:src="pathimagemvisualizar"> 
                                        <img v-else class="img-fluid img-filial" v-bind:src="pathimagemvisualizar">                                         
                                    </div>
                                </div>
                            </div>
                        </div>
						<div class="row">
							<div class="col-md-12">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#dvendereco">Endereço</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvfaturamento">Faturamento</a>
                                    </li>                                    
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvfinanceiro">Financeiro</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvformula">Fórmula custo(produtos)</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvplanos">*Planos de pagamento</a>
                                    </li>                                    																		
                                </ul>
								<div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                                    <div id="dvendereco" class="container-fluid tab-pane active">
                                        <div class="row">
											<div class="col-sm-12 col-md-2 col-lg-2">
												<label for="edcep">*CEP:</label>
												<input type="text" v-mask="'#####-###'" class="form-control form-control-sm"
													id="edcep" v-model="vcep" v-bind:disabled="ativadesativa"
													data-bv-group=".group" maxlength="10">
											</div>
											<div class="col-sm-12 col-md-4 col-lg-4">
												<label for="edlogradouro">*Logradouro:</label>
												<input type="text" class="form-control form-control-sm" id="edlogradouro"
													v-model="vlogradouro" v-bind:disabled="ativadesativa"
													data-bv-group=".group" maxlength="100">
											</div>
											<div class="col-sm-12 col-md-2 col-lg-2">
												<label for="ednumeroendereco">*Número:</label>
												<input type="text" class="form-control form-control-sm" id="ednumeroendereco"
													v-model="vnumeroendereco" v-bind:disabled="ativadesativa"
													data-bv-group=".group" maxlength="20">
											</div>
											<div class="col-sm-12 col-md-4 col-lg-4">
												<label for="edreferencia">Referência:</label>
												<input type="text" class="form-control form-control-sm" id="edreferencia"
													v-model="vreferencia" v-bind:disabled="ativadesativa"
													data-bv-group=".group" maxlength="100">
											</div>

											<div class="col-sm-12 col-md-6 col-lg-6">
												<span class="lblselect2">*Bairro:</span>
												<select id="cbbairro" v-model="vidbairro" v-bind:disabled="ativadesativa"
														data-placeholder="Selecione uma opção" data-allow-clear="true"
														style="width:100%;">
												</select>
											</div>
											<div class="col-sm-12 col-md-4 col-lg-4">
												<span class="lblselect2">*Município:</span>
												<select id="cbmunicipio" v-model="vidmunicipio"
														v-bind:disabled="ativadesativa"
														data-placeholder="Selecione uma opção" data-allow-clear="true"
														style="width:100%;">
												</select>
											</div>
											<div class="col-sm-12 col-md-2 col-lg-2">
												<span class="lblselect2">*UF:</span>
												<select id="cbuf" v-model="viduf" v-bind:disabled="ativadesativa"
														data-placeholder="Selecione a uf" data-allow-clear="true"
														style="width:100%;">
												</select>
											</div>											
                                        </div>
                                    </div>
									<div id="dvfaturamento" class="container-fluid tab-pane">
                                        <div class="row">
                                            <div class="col-md-12">                                                
                                                <div class="card">
                                                    <div class="card-header card-in">VALORES PADRÃO (PEDIDOS)</div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <span class="lblselect2">*Estoque padrão:</span>
                                                                <select id="cbestoque" data-placeholder="Selecione um estoque" v-model="videstoque" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                                </select>
                                                            </div>
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <span class="lblselect2">*Vendedor:</span>
                                                                <select id="cbvendedor" data-placeholder="Selecione um plano" v-model="vidvendedor" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                                </select>
                                                            </div>                                                            
                                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                                <span class="lblselect2">*Cliente padrão:</span>
                                                                <select id="cbcliente" data-placeholder="Selecione um cliente" v-model="vidcliente" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                                </select>
                                                            </div>
                                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                                <span class="lblselect2">*Plano padrão:</span>
                                                                <select id="cbplano" data-placeholder="Selecione um plano" v-model="vidplano" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                                </select>
                                                            </div>
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbimprimelogocupom">Imprimir logo no cupom:</label>
                                                                <select class="form-control form-control-sm" id="cbimprimelogocupom" v-model="vimprimelogocupom"
                                                                        v-bind:disabled="ativadesativa">
                                                                    <option value="0">Não</option>
                                                                    <option value="1">Sim</option>
                                                                </select>
                                                            </div>
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbinfoimp">Informações na impressão:</label>
                                                                <select class="form-control form-control-sm" id="cbinfoimp" v-model="vinfofilial"
                                                                        v-bind:disabled="ativadesativa">
                                                                    <option value="0">Não</option>
                                                                    <option value="1">Sim</option>
                                                                </select>
                                                            </div>
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbativarbalanca">Ativar balança:</label>
                                                                <select class="form-control form-control-sm" id="cbativarbalanca" v-model="vativarbalanca"
                                                                        v-bind:disabled="ativadesativa">
                                                                    <option value="0">Não</option>
                                                                    <option value="1">Sim</option>
                                                                </select>
                                                            </div> 
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbcreditoindividual">Cashback individual:</label>
                                                                <select class="form-control form-control-sm" id="cbcreditoindividual" v-model="vcreditoindividual"
                                                                        v-bind:disabled="ativadesativa">
                                                                    <option value="0">Não</option>
                                                                    <option value="1">Sim</option>
                                                                </select>
                                                            </div> 
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="edfatorcreditoutilizar">Utilizar cashback(%):</label>
                                                                <money type="text" class="form-control form-control-sm" id="edfatorcreditoutilizar" v-model="vfatorcreditoutilizar"
                                                                        v-bind="money" v-bind:disabled="ativadesativa"
                                                                        data-bv-group=".group" style="text-align:right;" title="Percentual permitido para utilização do total da venda/recebimento"></money>
                                                            </div>                                                                                                                        
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbativarcashback">Ativar Cashback:</label>
                                                                <select class="form-control form-control-sm" id="cbativarcashback" v-model="vativacashback"
                                                                        v-bind:disabled="ativadesativa">
                                                                    <option value="0">Não</option>
                                                                    <option value="1">Sim</option>
                                                                </select>
                                                            </div>                                
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="edvalidadecashback">Validade Cashback(dias):</label>
                                                                <input type="number" v-model="vvalidadecashback" v-bind:disabled="ativadesativa"
                                                                    class="form-control form-control-sm" id="edvalidadecashback" maxlength="11" min="0" title="validade em dias dias">
                                                            </div>
                                                            <div class="col-sm-12 col-md-10 col-lg-10">
                                                                <label for="eddescricao">*Mensagem rodapé dos pedidos:</label>
                                                                <input type="text" v-model="vmensagempedido" v-bind:disabled="ativadesativa"
                                                                    class="form-control form-control-sm" id="eddescricao" maxlength="200">
                                                            </div> 
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbreciborodape">Recibo no rodapé:</label>
                                                                <select class="form-control form-control-sm" id="cbreciborodape" v-model="vreciborodape"
                                                                        v-bind:disabled="ativadesativa">
                                                                    <option value="0">Não</option>
                                                                    <option value="1">Sim</option>
                                                                </select>
                                                            </div>                                                        
                                                        </div>
                                                    </div>
                                                </div>                                            
                                            </div>
                                            <div class="col-md-12" style="margin-top: 15px;">                                                
                                                <div class="card">
                                                    <div class="card-header card-in">VALORES PADRÃO (NOTAS FISCAIS)</div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-10">
                                                                <div class="row">
                                                                    <div class="col-sm-12 col-md-12 col-lg-12">
                                                                        <label for="cbcrt">Regime tributário:</label>
                                                                        <select name="cbmod" class="form-control form-control-sm" id="cbcrt" v-model="vcrt">
                                                                            <option value="1">Simples Nacional</option>
                                                                            <option value="2">Simples Nacional - excesso de sublimite de receita bruta</option>
                                                                            <option value="3">Regime Normal</option>
                                                                        </select>
                                                                    </div>                                                            
                                                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                                                        <span class="lblselect2">*Natureza de operação:</span>
                                                                        <select id="cbnatop" data-placeholder="Selecione um registro" v-model="vidnatop" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                                        </select>
                                                                    </div> 
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <label for="edserie">*Série NF-e:</label>
                                                                        <input type="number" v-model="vserie55" v-bind:disabled="ativadesativa"
                                                                            class="form-control form-control-sm" id="edserie" maxlength="3">
                                                                    </div>
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <label for="edserie">*Nr. inicial da NF-e:</label>
                                                                        <input type="number" v-model="vnnf55" v-bind:disabled="ativadesativa"
                                                                            class="form-control form-control-sm" id="edserie" maxlength="11">
                                                                    </div> 
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <label for="edserie">*Série NFC-e:</label>
                                                                        <input type="number" v-model="vserie65" v-bind:disabled="ativadesativa"
                                                                            class="form-control form-control-sm" id="edserie" maxlength="3">
                                                                    </div>
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <label for="edserie">*Nr. inicial da NFC-e:</label>
                                                                        <input type="number" v-model="vnnf65" v-bind:disabled="ativadesativa"
                                                                            class="form-control form-control-sm" id="edserie" maxlength="11">
                                                                    </div>                                                             
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <label for="edcnae">CNAE:</label>
                                                                        <input type="text" v-model="vcnae" v-bind:disabled="ativadesativa"
                                                                            class="form-control form-control-sm" id="edcnae" maxlength="7">
                                                                    </div> 
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <label for="edsenhacertificado">Senha certificado:</label>
                                                                        <input type="password" v-model="vsenhacertificado" v-bind:disabled="ativadesativa"
                                                                            class="form-control form-control-sm" id="edsenhacertificado" maxlength="20">
                                                                    </div>
                                                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                                                        <label for="edcsc">CSC:</label>
                                                                        <input type="text" v-model="vcsc" v-bind:disabled="ativadesativa"
                                                                            class="form-control form-control-sm" id="edcsc" maxlength="50">
                                                                    </div>
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <label for="edcscid">Id. CSC:</label>
                                                                        <input type="text" v-model="vcscid" v-bind:disabled="ativadesativa"
                                                                            class="form-control form-control-sm" id="edcscid" maxlength="50">
                                                                    </div>
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <label for="cbtpamb">Tipo de ambiente:</label>
                                                                        <select class="form-control form-control-sm" id="cbtpamb" v-model="vtpamb"
                                                                                v-bind:disabled="ativadesativa">
                                                                            <option value="1">Produção</option>
                                                                            <option value="2">Homologação</option>
                                                                        </select>
                                                                    </div> 
                                                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                                                        <span class="lblselect2">*Classe padrão:</span>
                                                                        <select id="cbclasse" data-placeholder="Selecione uma classe" v-model="vidclasse" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;" title="Valor que será atribuído ao protudo caso não esteja atribuído para a filial no cadastro">
                                                                        </select>
                                                                    </div> 
                                                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                                                        <span class="lblselect2">Inf. complementar padrão:</span>
                                                                        <select id="cbinfcomplementar" data-placeholder="Selecione a informação complementar" v-model="vidinformacaocomplementar" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                                        </select>
                                                                    </div>                                                              
                                                                    <!-- <div class="col-sm-12 col-md-4 col-lg-4">
                                                                        <label for="edemailautomaticoxml">E-mail automático xmls:</label>
                                                                        <input type="email" class="form-control form-control-sm" id="edemailautomaticoxml" v-model="vemailautomaticoxml"
                                                                            data-bv-group=".group" v-bind:disabled="ativadesativa" maxlength="100" title="Informe o e-mail ao qual serão enviados automaticamente os xmls das NFs emitidas.">
                                                                    </div>                                                                                                                                                                                                                                              -->
                                                                    <div v-if="lstcertificados.length === 0" class="col-md-12 text-center" style="margin-top: 15px;">
                                                                        <input
                                                                            type="file" 
                                                                            id="ipselecionarcertificado"
                                                                            accept=".pfx" 
                                                                            @change="mtdselecionarcertificado" 
                                                                            style="display: none;"
                                                                            ref="if_certfilial">                                                                
                                                                        <button type="button" @click="$refs.if_certfilial.click()" class="btn btn-success btn-verde"><i class="fa fa-certificate"></i> Selecionar arquivo de certificado A1</button>
                                                                    </div>
                                                                    <div v-if="lstcertificados.length > 0" class="col-md-12" style="margin-top: 15px;">
                                                                        <ul class="list-group">
                                                                            <li v-for="(arquivo, index) in lstcertificados" v-bind:key="index" class="list-group-item list-group-item-action">
                                                                                <div class="row">
                                                                                    <div class="col-md-1 text-center">
                                                                                        <i class="fa fa-lock" style="font-size: 26px; color: #4250f2;"></i>
                                                                                    </div>
                                                                                    <div class="col-md-11">                                                                                
                                                                                        <div class="col-md-12">
                                                                                            <a v-bind:href="adrsrvcert +'/'+ arquivo.patharquivo" class="btn btn-info btn-baixar-certificado" role="button" title="Baixar certificado" target="_blank"><i class="fa fa-download"></i></a>
                                                                                            <h5 style="font-size: 18px; color: #6c757d; font-weight: bold; margin-bottom: -1px;">{{ arquivo.nome }} - {{ formatadoc(arquivo.cnpjcpf) }}</h5>
                                                                                            <h5 style="font-size: 14px; color: #6c757d; margin-bottom: -1px;">{{ arquivo.emissor }}</h5>
                                                                                            <h5 style="font-size: 14px; color: #6c757d; margin-bottom: -1px;">{{ arquivo.email }}</h5>
                                                                                            <h5 style="font-size: 14px; color: #6c757d; margin-bottom: -1px;">{{ arquivo.validade }}</h5>
                                                                                        </div>
                                                                                        <div class="col-md-12" style="margin-top: 10px;">
                                                                                            <span id="op_exc_cert" @click.prevent="mtdexcluircertificado(arquivo.patharquivo)"><i class="fa fa-lock"></i> <strong>Remover certificado</strong></span><br>
                                                                                            <span style="font-size: 10px; color: #6c757d;"><strong>* Caso o certificado seja removido, não manteremos backup do mesmo.</strong></span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>                                                                                                                                                
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-2">
                                                                <div class="row">
                                                                    <div class="col-12">
                                                                        <label for="edidprodutoprod">CPF/CNPJ autorizado:</label>
                                                                        <div class="input-group" style="z-index: 1;">
                                                                            <input type="text" title="Adicionar terceiros que podem consultar as XMLs das NFE emitidas." class="form-control form-control-sm" id="edidprodutoprod" v-mask="['###.###.###-##', '##.###.###/####-##']" v-model="vcpfcnpjaut" maxlength="20">
                                                                            <div class="input-group-append">
                                                                                <a href="#"  class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdaddcpfcnpjaut()" ><i  class="fa fa-plus" style="padding-top: 3px;"></i></a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-12" style="margin-top: 20px;">
                                                                        <ul class="list-group">
                                                                            <li v-for="(item, index) in lstcpfcnpjaut" :key="index" class="optask-list list-group-item d-flex justify-content-between align-items-center list-group-item-action">
                                                                                <span><i @click.prevent="mtdexcluircpfcnpjaut(item)" class="fa fa-trash" style="color: #e23333; cursor: pointer"></i></span>
                                                                                <span style="font-size: 12px; font-weight: bold;">{{  formatadoc(item.cpfcnpj) }}</span>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>  
                                                            </div>      
                                                        </div> 
                                                    </div>
                                                </div>                                            
                                            </div>                                            
                                        </div>										
									</div>                                     
                                    <div id="dvfinanceiro" class="container-fluid tab-pane">
                                        <div class="row">
											<div class="col-12 col-sm-2 col-md-2 col-lg-2">
												<label for="cbtpjuros">Tipo Juros:</label>
												<select name="cbtpjuros" class="form-control form-control-sm" id="cbtpjuros" v-model="vtpjuros" v-bind:disabled="ativadesativa">
													<option value=0>Simples</option>
													<option value=1>Composto</option>
												</select>
											</div>											
											<div class="col-12 col-sm-2 col-md-2 col-lg-2">
												<label for="cbtpcaljuros">Tp. Cálculo juros:</label>
												<select name="cbtpcalcjuros" class="form-control form-control-sm" id="cbtpcalcjuros" v-model="vtpcalcjuros" v-bind:disabled="ativadesativa">
													<option value=0>Percentual</option>
													<option value=1>Valor</option>
												</select>
											</div>
											<div class="col-sm-12 col-md-2 col-lg-2">
												<label for="edfatjuros">Fator Juros:</label>
												<money type="text" class="form-control form-control-sm" id="edfatjuros" v-model="vfatjuros"
														v-bind="money" v-bind:disabled="ativadesativa"
														data-bv-group=".group" style="text-align:right;"></money>
											</div>																						
											<div class="col-12 col-sm-2 col-md-2 col-lg-2">
												<label for="cbtpcalmulta">Tp. Cálculo Multa:</label>
												<select name="cbtpcalmulta" class="form-control form-control-sm" id="cbtpcalmulta" v-model="vtpcalcmulta" v-bind:disabled="ativadesativa">
													<option value=0>Percentual</option>
													<option value=1>Valor</option>
												</select>
											</div>
											<div class="col-sm-12 col-md-2 col-lg-2">
												<label for="edfatmulta">Fator Juros:</label>
												<money type="text" class="form-control form-control-sm" id="edfatmulta" v-model="vfatmulta"
														v-bind="money" v-bind:disabled="ativadesativa"
														data-bv-group=".group" style="text-align:right;"></money>
											</div>
											<div class="col-sm-12 col-md-2 col-lg-2">
												<span class="lblselect2">*Cobrador:</span>
												<select id="cbcobrador" v-model="vidcobrador" v-bind:disabled="ativadesativa"
														data-placeholder="Selecione um cobrador" data-allow-clear="true"
														style="width:100%;">
												</select>
											</div>																																																																		
                                        </div>
                                    </div>                                   																			
									<div id="dvformula" class="container-fluid tab-pane">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <textarea class="form-control center" rows="8" id="txtformula" v-model="vformulacustoproduto" v-bind:disabled="ativadesativa"></textarea>
                                            </div>                                          
                                        </div>										
									</div>
									<div id="dvplanos" class="container-fluid tab-pane">
                                        <div class="row">
                                            <div v-show="parseInt(opcrud) < 3" class="col-sm-12 col-md-6 col-lg-6">
                                                <label for="cbplanopagamento">Plano de pagamento:</label>
                                                <select id="cbplanopagamento" data-placeholder="Selecione um plano" data-allow-clear="true"
                                                        style="width:100%;" v-model="vidplanolst" v-bind:disabled="ativadesativa">
                                                </select>
                                            </div>
                                            <div v-if="parseInt(opcrud) < 3" class="col-sm-12 col-md-2 col-lg-2">
                                                <button type="button" id="btincplano" class="btn btn-info btn-sm"
                                                        @click.prevent="mtdincplano()"
                                                        style="width:100%; margin-top: 21px;"><i class="fa fa-plus-circle"></i>
                                                    Incluir
                                                </button>
                                            </div> 
                                            <div v-if="lstplanos.length > 0" class="col-lg-12">
                                                <div class="table-responsive">
                                                    <table id="tblistaplanos" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                        <thead class="thead-light">
                                                        <tr>
                                                            <th>Plano de pagamento:</th>
                                                            <th v-if="parseInt(opcrud) < 3" width="35px" style="text-align: center;">Exc:</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody id="lstplanosfilial">
                                                            <tr v-for="(plano, index) in lstplanos" v-bind:key="index">
                                                                <td>{{mtdformatarzeros(plano.idplano, 2)}} - {{ plano.descplano }}</td>
                                                                <td v-if="parseInt(opcrud) < 3" width="35px" class="center" style="text-align: center;">
                                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                    v-bind:disabled="ativadesativa"
                                                                    @click.prevent="mtddeletaplano(index)"><i class="fa fa-trash"></i></a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>                                                                                       
                                        </div>										
									</div>                                    
								</div>
							</div>                                                       
						</div>	
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'

    export default {
        name: 'cadfiliais',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb
        },
        data: function() {
            return {
                lstfiliais  : [],
                pfiltro      : 1,
                pconteudo    : '',
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,

                //endereco do servidor
                adrsrvcert            : '',  

                //variáveis do crud
                opcrud                :  0,
                vcodfil               : '',
                vdescfil              : '',
                vfantasia             : '',
                vtpjuros              : 0,
                vtpcalcjuros          : 0,
                vtpcalcmulta          : 0,
                vfatjuros             : 0,
                vfatmulta             : 0,
                vidcobrador           : null,
                vcep                  : '',
                vlogradouro           : '',
				vnumeroendereco       : '',
				vreferencia			  : '',
                vidbairro             : null,
                vidmunicipio          : null,
                viduf                 : null,
                vcnpj                 : '',
                vie                   : '',
                viest                 : '',
                vim                   : '',  
                vfone1                : '',
                vfone2                : '',
                vemail                : '',
                vsite                 : '',
                vdiretorioimagem      : '',
                vdiretoriocertificado : '',
                vsenhacertificado     : '',
                vcsc                  : '',
                vcscid                : '',   
                vlogo                 : '',                
                vformulacustoproduto  : '',
                videstoque            : null,
                vidvendedor           : null,
                vidcliente            : null,
                vidplano              : null,
                vidclasse             : null,
                vemailautomaticoxml   : '',
                vimprimelogocupom     : 0,    
                vmensagempedido       : '',
                vnatope               : '',
                vserie55              : 1,
                vnnf55                : 1,
                vserie65              : 1,
                vnnf65                : 1,                
                vcnae                 : '',
                vcrt                  : '1',
                vtpamb                : 2,
                vidnatop              : null,
                vativarbalanca        : 1,  
                vcreditoindividual    : 0,
                vfatorcreditoutilizar : 100,
                vativacashback        : 0,  
                vvalidadecashback     : 0,  
                lstplanos             : [],
                lstcertificados       : [],  
                vinfofilial           : 1,
                vreciborodape         : 0,

                //variável para habilitação dos campos
				ativadesativa         : true,
                
                //rotina dos planos
                vidplanolst           : null,
                vdesconto             : 0,  


                /// terceiros autorizados
                vcpfcnpjaut           : '',
                lstcpfcnpjaut         : [],

                //rotina imagens
                arqimgselecionado     : null,

                //pega o path do diretorio padrão das imagens
                pathimgview           : this.$store.state.configpaths.pathimagens,

                //rotina do certificado
                arqcertselecionado    : null,

                //path com o caminho pronto da logo da filial para visualização
                pathimagemvisualizar  : '',

                money: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },				

                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'FILIAIS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "codfil",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Razão Social",
                        name: "descfil",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Fantasia",
                        name: "fantasia",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    }                    
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
       
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},     
            mtdaddcpfcnpjaut(){

                /// verifica se tem forma valida - guga
                const cpfcnpj = this.vcpfcnpjaut.replace(/[^0-9]/g, ''); 
                const isCpf = cpfcnpj.length === 11; 
                const isCnpj = cpfcnpj.length === 14; 

                if (!isCpf && !isCnpj) {
                    this.$toastr.w('CPF ou CNPJ inválido!', 'Informação!');
                    return; 
                }
    
                /// outras verificações - guga
                if(this.vcnpj === this.vcpfcnpjaut){
                    this.$toastr.w('O CNPJ do autorizado não pode ser o mesmo da filial!', 'Informação!'); 
                }else if(this.lstcpfcnpjaut.length === 10){
                    this.$toastr.w('A quantidade de autorizados não pode ser superior a 10!', 'Informação!'); 
                }
                else if(util.findValInArray(this.lstcpfcnpjaut, 'cpfcnpj', this.vcpfcnpjaut.replace(/[^0-9]/g, ''))){
                    this.$toastr.w('Autorizado já incluso!', 'Informação!'); 
                }else{
                    let docterceiro = {
                       'cpfcnpj' : this.vcpfcnpjaut.replace(/[^0-9]/g, ''),
                    }
                    this.lstcpfcnpjaut.push(docterceiro)
                    this.vcpfcnpjaut = '';
                }
            },  
            mtdexcluircpfcnpjaut(item){
                let indiceitem 		= util.getArrayIndexForKey(this.lstcpfcnpjaut, 'cpfcnpj', item.cpfcnpj);
                this.lstcpfcnpjaut.splice(indiceitem, 1);                
            },     
            formatavalores:function (val) {
                return util.formatarvalor(val, '');
            },
            formatadoc(doc){
                return util.formatacpfcnpj(doc);
            },
            mtdselecionarcertificado(event){
                let vself = this;           
                if (vself.vsenhacertificado === ''){
                    vself.$toastr.w('Informe, primeiramente, a senha do certificado!', 'Informação!'); 
                    vself.arqcertselecionado    = null;
                    $('#ipselecionarcertificado').val('');
                    $('#edsenhacertificado').focus();
                    return;
                }   
                if (vself.vcnpj === ''){
                    vself.$toastr.w('Informe o CNPJ do emissor!', 'Informação!'); 
                    vself.arqcertselecionado    = null;
                    $('#ipselecionarcertificado').val('');
                    $('#edcnpj').focus();
                    return;
                }                   
                vself.arqcertselecionado = event.target.files[0];
                let extensao = util.extensaoarquivo(vself.arqcertselecionado);
                if (extensao.toUpperCase() !== 'PFX'){
                   vself.$toastr.w('Arquivo de certificado inválido!', 'Informação!'); 
                }else{
                    let loader      = vself.$loading.show();
                    let localsalvar = vself.$store.state.configpaths.pathcertificados + vself.$store.state.filialpadrao.idcliente+'/'+vself.vdiretoriocertificado;

                    let parametros      = [
                        {parametro: 'arquivo',          valor  : vself.arqcertselecionado},
                        {parametro: 'localsalvar',      valor  : localsalvar},
                        {parametro: 'nomearquivo',      valor  : vself.arqcertselecionado.name},
                        {parametro: 'origem',           valor  : 'certificado'},
                        {parametro: 'senhacertificado', valor  : vself.vsenhacertificado}
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                    retorno.then(function (response) {
                        if ($.isNumeric(response.data.inf)){
                            vself.lstcertificados       = response.data.arquivos;
                            vself.arqcertselecionado    = null;
                            $('#ipselecionarcertificado').val('');
                            if (response.data.arquivos[0].nome === ''){
                                vself.$toastr.w('Impossível ler as informações do certificado. Verifique a senha e tente novamente!', 'Informação!');
                                vself.mtdconfirmaexclusaocertificado(response.data.arquivos[0].patharquivo);
                                loader.hide();
                                return;
                            }
                            if (response.data.arquivos[0].cnpjcpf !== null){
                                if (response.data.arquivos[0].cnpjcpf !== vself.vcnpj.replace(/[^\d]+/g,'')){
                                    vself.$toastr.w('CNPJ não pertence ao emissor cadastrado!', 'Informação!');
                                    vself.mtdconfirmaexclusaocertificado(response.data.arquivos[0].patharquivo);
                                    loader.hide();
                                    return;
                                }     
                            }                       
                            vself.$toastr.s('Arquivo enviado com sucesso!', 'Informação!');
                        }else{                       
                            vself.arqcertselecionado = null;
                            $('#ipselecionarcertificado').val('');
                            vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                        }
                        loader.hide();
                    }).catch(function (response) {
                        loader.hide();
                        vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');                       
                        vself.arqcertselecionado = null;
                        $('#ipselecionarcertificado').val('');
                    });     
                }
            },
            mtdexcluircertificado(nomearquivo){
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma remoção do certificado?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdconfirmaexclusaocertificado(nomearquivo);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            }
                        }
                    }
                });
            },  
            mtdconfirmaexclusaocertificado(nomearquivo){
                let vself        = this;
                let loader       = vself.$loading.show();
                let localarquivo = vself.$store.state.configpaths.pathcertificados + 
                                vself.$store.state.filialpadrao.idcliente +'/'+
                                vself.vdiretoriocertificado;

                let parametros      = [
                    {parametro: 'op',               valor  : "excluirarquivo"},
                    {parametro: 'patharquivo',      valor  : nomearquivo},
                    {parametro: 'localarquivo',     valor  : localarquivo}
                    
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.$toastr.s('Certificado removido!', 'Informação!');
                        vself.lstcertificados = response.data.arquivos;
                    }else{                        
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });                                                  
            },                 
            mtdselecionarimagemfilial(event){                
                let vself = this;                 
                vself.arqimgselecionado = event.target.files[0];
                let loader      = vself.$loading.show();
                let localsalvar = vself.$store.state.configpaths.pathimgfiliais + vself.$store.state.filialpadrao.idcliente+'/'+vself.vdiretorioimagem;

                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.arqimgselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : vself.arqimgselecionado.name}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.vlogo                = localsalvar+'/'+vself.arqimgselecionado.name;                        
                        vself.arqimgselecionado    = null;
                        vself.pathimagemvisualizar = vself.pathimgview+vself.vlogo;
                        vself.$toastr.s('Imagem enviada com sucesso!', 'Informação!');
                        $('#ipselecionarimgfilial').val('');
                    }else{
                        vself.vlogo             = '';                        
                        vself.arqimgselecionado = null;
                        $('#ipselecionarimgfilial').val('');
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    vself.vlogo             = '';                        
                    vself.arqimgselecionado = null;
                    $('#ipselecionarimgfilial').val('');
                });                
            },
            mtdexcluirimgfilial(){
                let vself = this;
                if (!util.contemstring(vself.pathimagemvisualizar, 'semimagem')){                    
                    let loader       = vself.$loading.show();
                    let localarquivo = vself.$store.state.configpaths.pathimgfiliais + 
                                    vself.$store.state.filialpadrao.idcliente +'/'+
                                    vself.vdiretorioimagem;

                    let parametros      = [
                        {parametro: 'op',               valor  : "excluirarquivo"},
                        {parametro: 'patharquivo',      valor  : vself.vlogo},
                        {parametro: 'localarquivo',     valor  : localarquivo}
                        
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                    retorno.then(function (response) {
                        if ($.isNumeric(response.data.inf)){
                            vself.$toastr.s('Imagem excluída com sucesso!', 'Informação!');
                            vself.vlogo = '';
                            vself.pathimagemvisualizar = vself.$store.state.configpaths.pathimagens+'imagens/semimagem.png';
                        }else{                        
                            vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                        }
                        loader.hide();
                    }).catch(function (response) {
                        loader.hide();
                        vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    });                  
                }
            },            
            mtdselect2_def(){
                let vself = this;
                //selects do crud
                $("#cbcobrador").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcobradores',
                                    c1: 'id',
                                    c2: 'nome'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidcobrador = $("#cbcobrador").val();
                });
                $("#cbbairro").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbbairros',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 2,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidbairro = $("#cbbairro").val();
                });
                $("#cbmunicipio").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbmunicipios',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 2,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidmunicipio = $("#cbmunicipio").val();
                });
                $("#cbuf").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbufs',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.viduf = $("#cbuf").val();
                });
                $("#cbplanopagamento").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbplanospagamento',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidplanolst = $("#cbplanopagamento").val();
                });
                $("#cbclasse").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbclassesimpostos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidclasse = $("#cbclasse").val();
                });                                                
                $("#edcep").blur(function(){
                    vself.mtdpesquisacep();
                });
				$("#cbestoque").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.videstoque = $("#cbestoque").val();
                });
				$("#cbvendedor").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbvendedores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidvendedor = $("#cbvendedor").val();
				});				
                $("#cbcliente").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbclientes',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidcliente = $("#cbcliente").val();
                });
				$("#cbplano").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbplanospagamento',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidplano = $("#cbplano").val();
                });
                $("#cbnatop").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbnaturezasoperacoesnf',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidnatop = $("#cbnatop").val();
                });
                $("#cbinfcomplementar").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbinformacoescomplementares',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidinformacaocomplementar = $("#cbinfcomplementar").val();
                });                                                                                  
            },          
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and f.codfil='+this.pconteudo;
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(f.fantasia) like upper("'+this.pconteudo+'%")';
                }
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfiliais.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregafiliais(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregafiliais(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'diretoriocertificados', valor : vself.$store.state.configpaths.pathcertificados+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfiliais.php');
                retorno.then(function (response) {
                    vself.lstfiliais = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstfiliais = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();

                this.vcodfil                = '';
                this.vdescfil               = '';
                this.vfantasia              = '';
                this.vtpjuros               = 0;
                this.vtpcalcjuros           = 0;
                this.vtpcalcmulta           = 0;
                this.vfatjuros              = 0;
                this.vfatmulta              = 0;
                this.vidcobrador            = null;
                this.vcep                   = '';
                this.vlogradouro            = '';
				this.vnumeroendereco        = '';
				this.vreferencia			= '';
                this.vidbairro              = null;
                this.vidmunicipio           = null;
                this.viduf                  = null;
                this.vcnpj                  = '';
                this.vie                    = '';
                this.viest                  = '';
                this.vim                    = '';
                this.vfone1                 = '';
                this.vfone2                 = '';
                this.vemail                 = '';
                this.vsite                  = '';
                this.vlogo                  = '';
                this.vdiretorioimagem       = '';
                this.vdiretoriocertificado  = '';
                this.vsenhacertificado      = '';
                this.vcsc                   = '';
                this.vcscid                 = '',
                this.vformulacustoproduto   = 'PC + (PC * IPI) + ((PC + (PC * IPI) )* ICM) + ((PC + (PC * IPI)) * FT) + ((PC + (PC * IPI)) * OT) + (PV * PIS) + (PV * COF) + STB';
                this.videstoque             = null;  
                this.vmensagempedido        = '';
                this.vnatope                = '';
                this.vserie55               = 1;
                this.vnnf55                 = 1;
                this.vserie65               = 1;
                this.vnnf65                 = 1;                
                this.vcnae                  = '';
                this.vcrt                   = '1';
                this.vtpamb                 = 2;   
                this.vidnatop               = null;  
                this.vativarbalanca         = 1;  
                this.vcreditoindividual     = 0;
                this.vfatorcreditoutilizar  = 100;
                this.vativacashback         = 0;         
                this.vvalidadecashback      = 0;
                this.lstplanos              = [];
                this.lstcertificados        = [];
                this.lstcpfcnpjaut          = [];
                this.vcpfcnpjaut            = '';

                this.vinfofilial            = 1;
                this.vreciborodape          = 0;

                this.vidplano               = null;
                this.vidvendedor            = null;
                this.vidcliente             = null;
                this.vidclasse              = null;
                this.vemailautomaticoxml    = '';
                this.vimprimelogocupom      = 0;
                this.vdesconto              = 0;
                this.vidinformacaocomplementar = null;
                
                $('#cbcobrador').val(null).trigger('change');
                $('#cbbairro').val(null).trigger('change');
                $('#cbmunicipio').val(null).trigger('change');
                $('#cbestoque').val(null).trigger('change');
                $('#cbplanopagamento').val(null).trigger('change');
                $('#cbclasse').val(null).trigger('change');
                $('#cbuf').val(null).trigger('change');                
                $('#cbcliente').val(null).trigger('change');
                $('#cbinfcomplementar').val(null).trigger('change');
            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
				$('#pncadastro').fadeIn(700);
				$('.nav-tabs a[href="#dvendereco"]').tab('show');
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#eddescricao').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('002Z.001J.001L', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo   = 'INCLUSÃO DE FILIAIS';
                    this.itensbc.item1.ativo    = true;
                    this.itensbc.item2.ativo    = true;
                    this.ativadesativa          = false;
                    this.mtdpreparacrud(1);
                    this.vdiretorioimagem       = util.GerarStringAleatoria();
                    this.vdiretoriocertificado  = util.GerarStringAleatoria();
                    this.pathimagemvisualizar   = this.$store.state.configpaths.pathimagens+'imagens/semimagem.png';
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstfiliais = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                if (vself.lstcertificados.length > 0){
                    if (vself.lstcertificados[0].cnpjcpf !== null){
                        if (vself.lstcertificados[0].cnpjcpf !== vself.vcnpj.replace(/[^\d]+/g,'')){
                            vself.$toastr.w('CNPJ do emissor difere do CNPJ cadastrado no certificado!', 'Informação!');
                            $('#edcnpj').focus();
                            return;
                        }     
                    }           
                }
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                if (parseFloat(vself.vfatorcreditoutilizar) < 0){
                    vself.$toastr.w('Fator de utiização de cashbak inválido', 'Atenção!');
                    $('#edfatorcreditoutilizar').focus();
                    return;
                }                
                if (parseFloat(vself.vfatorcreditoutilizar) > 100){
                    vself.$toastr.w('Fator de utiização de cashbak não pode ultrapassar os 100%!', 'Atenção!');
                    $('#edfatorcreditoutilizar').focus();
                    return;
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and f.codfil='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'diretoriocertificados', valor : vself.$store.state.configpaths.pathcertificados+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfiliais.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('002Z.001J.002L', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE FILIAIS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.codfil);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('002Z.001J.003L', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE FILIAIS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.codfil);
                }
            },
            mtdigualarcampos(registro){
                this.vcodfil                  = registro.codfil;
                this.vdescfil                 = registro.descfil;
                this.vfantasia                = registro.fantasia;
                this.vtpjuros                 = registro.tpjuros;
                this.vtpcalcjuros             = registro.tpcalcjuros;
                this.vtpcalcmulta             = registro.tpcalcmulta;
                this.vfatjuros                = parseFloat(registro.fatjuros);
                this.vfatmulta                = parseFloat(registro.fatmulta);
                this.vidcobrador              = registro.idcobrador;
                this.vcep                     = registro.cep;
                this.vlogradouro              = registro.logradouro;
				this.vnumeroendereco          = registro.numeroendereco;
				this.vreferencia			  = registro.referencia;
                this.vidbairro                = registro.idbairro;
                this.vidmunicipio             = registro.idmunicipio;
                this.viduf                    = registro.iduf;
                this.vcnpj                    = registro.cnpj;
                this.vie                      = registro.ie;
                this.viest                    = registro.iest;
                this.vfone1                   = registro.fone1;
                this.vfone2                   = registro.fone2;
                this.vemail                   = registro.email;
                this.vsite                    = registro.site;
                this.vdiretorioimagem         = registro.diretorioimagem      === '' ? util.GerarStringAleatoria() : registro.diretorioimagem;
                this.vdiretoriocertificado    = registro.diretoriocertificado === '' ? util.GerarStringAleatoria() : registro.diretoriocertificado;
                this.vsenhacertificado        = registro.senhacertificado;
                this.vcsc                     = registro.csc;
                this.vcscid                   = registro.cscid;  
                this.vlogo                    = registro.logo;
                this.vformulacustoproduto     = registro.formulacustoproduto;
                this.videstoque               = registro.idestoque;
                this.vidvendedor              = registro.idvendedor;
                this.vidcliente               = registro.idcliente;
                this.vidplano                 = registro.idplano;
                this.vimprimelogocupom        = registro.imprimelogocupom;  
                this.vidclasse                = registro.idclasse;
                this.vemailautomaticoxml      = registro.emailautomaticoxml;
                this.vmensagempedido          = registro.mensagempedido;
                this.vnatope                  = registro.natope;
                this.vserie55                 = registro.serie55;
                this.vnnf55                   = registro.nnf55;
                this.vserie65                 = registro.serie65;
                this.vnnf65                   = registro.nnf65;                
                this.vcnae                    = registro.cnae;
                this.vcrt                     = registro.crt;
                this.vtpamb                   = registro.tpamb;
                this.vidnatop                 = registro.idnatop; 
                this.vativarbalanca           = registro.ativarbalanca;
                this.vcreditoindividual       = registro.creditoindividual;
                this.vfatorcreditoutilizar    = registro.fatorcreditoutilizar;
                this.vativacashback           = registro.ativacashback;
                this.vvalidadecashback        = registro.validadecashback;
                this.vidinformacaocomplementar= registro.idinformacaocomplementar;
                this.vinfofilial              = registro.infofilialimp;
                this.vreciborodape            = registro.reciborodapeinp;

                this.lstplanos                = registro.planos;  
                this.lstcertificados          = registro.certificados;
                this.lstcpfcnpjaut            = registro.autorizados;  
                
                this.pathimagemvisualizar     = this.pathimgview+this.vlogo;

                var defcobrador  = new Option(registro.nomecobrador, this.vidcobrador, true, true);
                $('#cbcobrador').append(defcobrador).trigger('change');

                var defbairro  = new Option(registro.descbairro, this.vidbairro, true, true);
                $('#cbbairro').append(defbairro).trigger('change');                

                var defmunicipio  = new Option(registro.descmunicipio, this.vidmunicipio, true, true);
                $('#cbmunicipio').append(defmunicipio).trigger('change');                

                var defuf  = new Option(registro.descuf, this.viduf, true, true);
                $('#cbuf').append(defuf).trigger('change');

                var defestoque  = new Option(registro.descestoque, this.videstoque, true, true);
                $('#cbestoque').append(defestoque).trigger('change');                

                var defvendedor = new Option(registro.nomevendedor, this.vidvendedor, true, true);
                $('#cbvendedor').append(defvendedor).trigger('change');
                
                var defcliente  = new Option(registro.nomecliente, this.vidcliente, true, true);
                $('#cbcliente').append(defcliente).trigger('change');

                var defplano  = new Option(registro.descplano, this.vidplano, true, true);
                $('#cbplano').append(defplano).trigger('change');                

                var defclasse = new Option(registro.descclasse, this.vidclasse, true, true);
                $('#cbclasse').append(defclasse).trigger('change');                

                var defnatop = new Option(registro.descnatop, this.vidnatop, true, true);
                $('#cbnatop').append(defnatop).trigger('change');  
                
                if (parseInt(this.vidinformacaocomplementar) > 0){
                    var definfcomplementar = new Option(registro.descinfcomplementar, this.vidinformacaocomplementar, true, true);
                    $('#cbinfcomplementar').append(definfcomplementar).trigger('change');                
                }else{
                    $('#cbinfcomplementar').val(null).trigger('change');
                }
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'codfil'               : this.vcodfil,
					'descfil'              : this.vdescfil,
					'fantasia'             : this.vfantasia,
					'tpjuros'              : this.vtpjuros,
					'tpcalcjuros'          : this.vtpcalcjuros,
					'tpcalcmulta'          : this.vtpcalcmulta,
					'fatjuros'             : this.vfatjuros,
					'fatmulta'             : this.vfatmulta,
					'idcobrador'           : this.vidcobrador,
					'cep'                  : this.vcep.replace(/[^0-9]/g, ''),
					'logradouro'           : this.vlogradouro,
					'numeroendereco'       : this.vnumeroendereco,
					'referencia'		   : this.vreferencia,
					'idbairro'             : this.vidbairro,
					'idmunicipio'          : this.vidmunicipio,
					'iduf'                 : this.viduf,
					'cnpj'                 : this.vcnpj.replace(/[^0-9]/g, ''),
                    'ie'                   : this.vie,
                    'iest'                 : this.viest,
					'fone1'                : this.vfone1.replace(/[^0-9]/g, ''),
					'fone2'                : this.vfone2.replace(/[^0-9]/g, ''),
					'email'                : this.vemail,
                    'site'                 : this.vsite,
                    'diretorioimagem'      : this.vdiretorioimagem,
                    'diretoriocertificado' : this.vdiretoriocertificado,
                    'senhacertificado'     : this.vsenhacertificado,
                    'csc'                  : this.vcsc,
                    'cscid'                : this.vcscid, 
					'logo'                 : this.vlogo,
                    'formulacustoproduto'  : this.vformulacustoproduto,
                    'idestoque'            : this.videstoque,
                    'idvendedor'           : this.vidvendedor,
                    'idcliente'            : this.vidcliente,
                    'idplano'              : this.vidplano,
                    'idclasse'             : this.vidclasse,
                    'emailautomaticoxml'   : this.vemailautomaticoxml,
                    'imprimelogocupom'     : this.vimprimelogocupom, 
                    'mensagempedido'       : this.vmensagempedido,
                    'natope'               : this.vnatope,
                    'serie55'              : this.vserie55,
                    'nnf55'                : this.vnnf55,
                    'serie65'              : this.vserie65,
                    'nnf65'                : this.vnnf65,                    
                    'cnae'                 : this.vcnae,
                    'crt'                  : this.vcrt,
                    'tpamb'                : this.vtpamb,
                    'idnatop'              : this.vidnatop,
                    'ativarbalanca'        : this.vativarbalanca,
                    'creditoindividual'    : this.vcreditoindividual,
                    'fatorcreditoutilizar' : this.vfatorcreditoutilizar,
                    'ativacashback'        : this.vativacashback, 
                    'infofilialimp'        : this.vinfofilial, 
                    'reciborodapeinp'      : this.vreciborodape, 
                    'validadecashback'     : this.vvalidadecashback, 
                    'idinformacaocomplementar'  : this.vidinformacaocomplementar === null ? 0 : this.vidinformacaocomplementar,
                    'planos'                    : this.lstplanos ,
                    'autorizados'             : this.lstcpfcnpjaut
                };
                let parametros      = [
                    {parametro: 'idclientesac',             valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'diretorioimagens',         valor : vself.$store.state.configpaths.pathimgfiliais+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'diretoriocertificados',    valor : vself.$store.state.configpaths.pathcertificados+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',                       valor : 'rotinacrud'},
                    {parametro: 'opcrud',                   valor : vself.opcrud},
                    {parametro: 'registro',                 valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',                 valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',                valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',                    valor : parseInt(this.opcrud) === 1 ? '002Z.001J.001L' : parseInt(this.opcrud) === 2 ? '002Z.001J.002L' : '002Z.001J.003L'},
                    {parametro: 'idclisac',                 valor : vself.$store.state.filialpadrao.idcliente}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfiliais.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vcodfil;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregafiliais(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdpesquisacep(){
                let vself = this;
                let cepinf = vself.vcep;
                if ( cepinf != ''){
                    if (util.IsCEP(cepinf, '')){
                        let loader = vself.$loading.show();
                        let parametros = [
                            {parametro: 'param1', 		valor: 'consultarcep'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'cep', 			valor: cepinf}
                        ];
                        let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/buscarcep.php');
                        retorno.then(function (response) {
                            loader.hide();
                            if (response.data != '0') {
                                var defmun = new Option(response.data.descmunicipio, response.data.idmunicipio, true, true);
                                $('#cbmunicipio').append(defmun).trigger('change');

                                var defbai = new Option(response.data.descbairro, response.data.idbairro, true, true);
                                $('#cbbairro').append(defbai).trigger('change');

                                var defuf = new Option(response.data.descuf, response.data.iduf, true, true);
                                $('#cbuf').append(defuf).trigger('change');

                                vself.vlogradouro     = response.data.logradouro;
                                vself.vreferencia     = response.data.complemento;
                            }else{
                                vself.$toastr.w('CEP inválido ou inexistente!', 'Atenção!');
                            }					

                        }).catch(function (response) {
                            loader.hide();
                            console.log(response.message);
                        });
                    }
                }                
            },
            mtdincplano(){
                if (this.vidplanolst === null) {
                    this.$toastr.w('Plano de pagamento deve ser informado!', 'Atenção!');
                    $('#cbplanopagamento').focus();
                }else {
                    let plano = {
                        'idplano'      : this.vidplanolst,
                        'descplano'    : $('#cbplanopagamento').select2('data')[0]['text'],
                        'desconto'     : this.vdesconto
                    };
                    if (!util.findValInArray(this.lstplanos, 'idplano', plano.idplano)) {
                        this.lstplanos.push(plano);
                        this.vidplanolst     = null;
                        this.vdesconto       = 0;
                        $('#cbplanopagamento').val(null).trigger('change');
                        $('#cbplanopagamento').focus();
                    } else {
                        this.$toastr.w('Plano de pagamento já cadastrado!', 'Atenção!');
                        $('#cbplanopagamento').focus();
                    }
                }                
            },
            mtddeletaplano(index) {
                this.lstplanos.splice(index, 1);
            }
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('002Z.001J', vself.$store.state.perfilusuario)) {
                        vself.pathimgview  = vself.$store.state.configpaths.pathimagens;
                        vself.adrsrvcert   = 'https://www.'+vself.$store.state.usuario.adrsrv;
						$('#pnlista').fadeIn(700);
						vself.mtdselect2_def();
                        vself.mtdexecutapesquisa();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                return this.vdescfil         === ''   || 
                       this.vfantasia        === ''   || 
                       this.vfone1           === ''   ||
                       this.vlogradouro      === ''   || 
                       this.vnumeroendereco  === ''   || 
                       this.vidbairro        === null || 
                       this.vidmunicipio     === null || 
                       this.viduf            === null || 
                       this.vidcobrador      === null || 
                       this.lstplanos.length === 0    || 
                       this.videstoque       === null || 
                       this.vidvendedor      === null || 
                       this.vidcliente       === null || 
                       this.vidplano         === null || 
                       this.vidclasse        === null || 
                       this.vidnatop         === null ||
                       this.vcep             === '';
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregafiliais(val);
            }
        }
    }
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }
    .img-filial{
        cursor: pointer;
        width: 150px !important;
        height: 155px !important;
    }
    .btn-del-imgfilial{
        position: absolute;
        top: 10px;
        left: 10px;
    }    
    #op_exc_cert{
        cursor: pointer;
        color: #fa5c7c;
    }
    #op_exc_cert:hover{
        filter: brightness(90%)!important;
    }
    .btn-baixar-certificado{
        float: right;
        font-size: 12px!important;
        width: 25px!important;
        height: 25px!important;
        padding: 4px 0px 0px 0px !important;        
    }
</style>